import { generatePropertyShareText } from "./generatePropertyShareText";
import { ShareOptionsCommonConfigs } from "./shareVia";

export interface WhatsAppShareOptions {
  text: string;
  phoneNumber?: string; // with country code, no +
}

export interface WhatsAppShareResult {
  success: boolean;
  method: "whatsapp-url";
}

/**
 * Opens WhatsApp with pre-filled text.
 * Works on both mobile and desktop.
 * Text only. No attachments supported.
 */
export const sharePropertyToWhatsApp = (
  options: WhatsAppShareOptions,
): WhatsAppShareResult => {
  const { text, phoneNumber } = options;

  const encodedText = encodeURIComponent(text);

  const url = phoneNumber
    ? `https://wa.me/${phoneNumber}?text=${encodedText}`
    : `https://api.whatsapp.com/send?text=${encodedText}`;

  window.open(url, "_blank", "noopener,noreferrer");

  return {
    success: true,
    method: "whatsapp-url",
  };
};

/**
 * Share property data directly to WhatsApp
 */
export const sharePropertyDataToWhatsApp = (
  options: ShareOptionsCommonConfigs,
): WhatsAppShareResult => {
  const { property, propertyUrl, brochureImageUrl } = options;

  const finalUrl = propertyUrl || brochureImageUrl;

  const text = generatePropertyShareText(property, {
    platform: "whatsapp",
    includeLink: finalUrl,
  });

  return sharePropertyToWhatsApp({ text });
};
